import { Requests } from "../../../../types/requestCreditDataTypes";

import {
  Box,
  FormControl,
  FormLabel,
  Grid,
  GridItem,
  Input,
  Select,
} from "@chakra-ui/react";
interface requestsStepProps {
  savedData: Requests;
  updateData: (data: Requests) => void;
}

const RequestsStep: React.FC<requestsStepProps> = ({
  savedData,
  updateData,
}) => {
  // the wizard always passes an object; nothing to render until it does
  if (!savedData) {
    return null;
  }
  return (
    <Box>
      <Grid templateColumns={{ base: "1fr", md: "repeat(3, 1fr)" }} gap={5}>
        <GridItem colSpan={1}>
          <FormControl isRequired>
            <FormLabel>Credit Limit</FormLabel>
            <Input
              type="number"
              isInvalid={savedData?.credit_limit === 0}
              value={savedData?.credit_limit}
              onChange={(e) => {
                updateData({
                  ...savedData,
                  credit_limit: parseInt(e.target.value),
                });
              }}
            />
          </FormControl>
        </GridItem>

        <GridItem colSpan={{ base: 1, md: 2 }}>
          <FormControl isRequired>
            <FormLabel>Credit Period</FormLabel>
            <Select
              value={savedData?.credit_period}
              onChange={(e) => {
                updateData({
                  ...savedData,
                  credit_period: parseInt(e.target.value),
                });
              }}
            >
              <option value="">Select</option>

              <option key="30" value={30}>
                30 Days
              </option>
            </Select>
          </FormControl>
        </GridItem>
        <GridItem colSpan={{ base: 1, md: 3 }}>
          <FormControl isRequired>
            <FormLabel>Payment Mode</FormLabel>
            <Select
              value={savedData?.payment_mode}
              onChange={(e) => {
                updateData({
                  ...savedData,
                  payment_mode: e.target.value as "Cheque" | "EFT" | undefined,
                });
              }}
            >
              <option>Select</option>
              <option key="cheque" value={'Cheque'}>
                Cheque
              </option>
              <option key="eft" value={'EFT'}>
                EFT
              </option>
            </Select>
          </FormControl>
        </GridItem>
      </Grid>
    </Box>
  );
};

export default RequestsStep;
